import React from 'react';
import { Input } from 'reactstrap';

class CardPayment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cardInEdit: {
                NameOnCard: "",
                CardNumber: "",
                CardExpMonth: "",
                CardExpYear: "",
                CardCVC: "",
            },
            touched: {
                fullName: false,
                cardNumber: false,
                cardExpMonth: false,
                cardExpYear: false,
                cardCVC: false
            }
        };
    }

    componentDidMount() {
        if (this.props.onRef) {
            this.props.onRef(this);
        }

        if (this.props.paymentMethod) {
            this.setState({
                cardInEdit: this.props.paymentMethod
            });
        } else {
            this.props.cardStateChange({
                isActive: false,
                cardInfo: this.state.cardInEdit
            });
        }
    }

    onDialogInputChange = (event) => {
        let target = event.target;
        const value = target.value;
        const name = target.props ? target.props.name : target.name;

        const edited = this.state.cardInEdit;
        edited[name] = value;
        this.setState({
            cardInEdit: edited,
            isActive: true
        }, function () {
            this.props.cardStateChange({
                isActive: true,
                cardInfo: this.state.cardInEdit
            });
        });
    }

    handleCreditNumChange = (event) => {
        var originalValue = this.state.cardInEdit.CardNumber.replace(/\s/g, '');
        const value = event.target.value.replace(/\s/g, '').replace(/\D/g, '');
        const edited = this.state.cardInEdit;
        if ((value.match(/^[0-9999999999999999]|^$/) || value == "") && value.length <= 16) {
            edited.CardNumber = this.cc_format(value);
            this.setState({
                cardInEdit: edited
            }, function () {
                this.props.cardStateChange({
                    isActive: true,
                    cardInfo: this.state.cardInEdit
                });
            });
        }
        else {
            edited.CardNumber = this.cc_format(originalValue);
            this.setState({
                CardNumber: edited
            }, function () {
                this.props.cardStateChange({
                    isActive: true,
                    cardInfo: this.state.cardInEdit
                });
            });
        }
    }

    cc_format(value) {
        var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
        var matches = v.match(/\d{4,16}/g);
        var match = matches && matches[0] || '';
        var parts = [];

        for (var i = 0; i < match.length; i += 4) {
            parts.push(match.substring(i, i + 4))
        }

        if (parts.length) {
            return parts.join(' ');
        } else {
            return value;
        }
    }

    handleExpMonthChange = (event) => {
        var originalValue = this.state.cardInEdit.CardExpMonth;
        let value = event.target.value.replace(/\s/g, '');
        let isValid = true;
        const edited = this.state.cardInEdit;

        if (!value.match(/(^[01]$|^[0][123456789]$|^[1][012]$|^$)/)) {
            isValid = false;
        }

        if (isValid) {
            edited.CardExpMonth = value;
            this.setState({
                cardInEdit: edited
            }, function () {
                this.props.cardStateChange({
                    isActive: true,
                    cardInfo: this.state.cardInEdit
                });
            });
        }
        else {
            edited.CardExpMonth = originalValue;
            this.setState({
                cardInEdit: edited
            }, function () {
                this.props.cardStateChange({
                    isActive: true,
                    cardInfo: this.state.cardInEdit
                });
            });
        }
    }

    handleExpYearChange = (event) => {
        var originalValue = this.state.cardInEdit.CardExpYear;
        const value = event.target.value.replace(/\s/g, '');
        const edited = this.state.cardInEdit;
        if ((value.match(/^(0)$|^([0-9][0-9]*)$|^$/) || value == "") && value.length <= 2) {
            edited.CardExpYear = value;
            this.setState({
                cardInEdit: edited
            }, function () {
                this.props.cardStateChange({
                    isActive: true,
                    cardInfo: this.state.cardInEdit
                });
            });
        }
        else {
            edited.CardExpYear = originalValue;
            this.setState({
                cardInEdit: edited
            }, function () {
                this.props.cardStateChange({
                    isActive: true,
                    cardInfo: this.state.cardInEdit
                });
            });
        }
    }

    handleCVCChange = (event) => {
        var originalValue = this.state.cardInEdit.CardCVC;
        const value = event.target.value.replace(/\D/g, '');
        const edited = this.state.cardInEdit;
        if ((value.match(/^[0-9999]|$/) || value == "") && value.length <= 4) {
            edited.CardCVC = value;
            this.setState({
                cardInEdit: edited
            }, function () {
                this.props.cardStateChange({
                    isActive: true,
                    cardInfo: this.state.cardInEdit
                });
            });
        }
        else {
            edited.CardCVC = originalValue;
            this.setState({
                cardInEdit: edited
            }, function () {
                this.props.cardStateChange({
                    isActive: true,
                    cardInfo: this.state.cardInEdit
                });
            });
        }
    }

    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    setAllTouchedTrue() {
        this.setState({
            touched: {
                fullName: true,
                cardNumber: true,
                cardExpMonth: true,
                cardExpYear: true,
                cardCVC: true
            },
        });
    }

    render() {
        return (
            <div className="card-payment">
                <h3>CREDIT CARD INFORMATION:</h3>
                <div className="w-100 d-flex flex-wrap">
                    <div className="form-group col-sm-6">
                        <div>
                            <label htmlFor="NameOnCard"
                                className={this.state.touched.fullName && this.state.cardInEdit.NameOnCard === '' ? "error" : ""}
                            >Full Name on Card:</label>
                        </div>
                        <div>
                            <Input
                                type="text"
                                name="NameOnCard"
                                id="NameOnCard"
                                value={this.state.cardInEdit.NameOnCard ?? ""}
                                onChange={this.onDialogInputChange}
                                invalid={this.state.touched.fullName && this.state.cardInEdit.NameOnCard === '' ? true : false}
                                onBlur={this.handleBlur('fullName')}
                            />
                        </div>
                    </div>
                    <div className="form-group col-sm-6">
                        <div>
                            <label htmlFor="CardNumber"
                                className={this.state.touched.cardNumber && this.state.cardInEdit.CardNumber === '' ? "error" : ""}
                            >Card Number:</label>
                        </div>
                        <div>
                            <Input
                                type="text"
                                name="CardNumber"
                                id="CardNumber"
                                placeholder="XXXX XXXX XXXX XXXX"
                                pattern="\d{4} \d{4,6} \d{4,5} \d{4,0}"
                                value={this.state.cardInEdit.CardNumber ?? ""}
                                onChange={this.handleCreditNumChange}
                                onBlur={this.handleBlur('cardNumber')}
                                className={this.state.touched.cardNumber && this.state.cardInEdit.CardNumber === '' ? "error" : ""}
                            />
                        </div>
                    </div>

                    <div className="form-group col-sm-3">
                        <div>
                            <label htmlFor="CardExpMonth"
                                className={this.state.touched.cardExpMonth && this.state.cardInEdit.CardExpMonth === '' ? "error" : ""}
                            >Exp Month:</label>
                        </div>
                        <div>
                            <Input
                                type="text"
                                name="CardExpMonth"
                                id="CardExpMonth"
                                placeholder="MM"
                                pattern="[0123456789][0123456789]"
                                value={this.state.cardInEdit.CardExpMonth ?? ""}
                                onChange={this.handleExpMonthChange}
                                onBlur={this.handleBlur('cardExpMonth')}
                                className={this.state.touched.cardExpMonth && this.state.cardInEdit.CardExpMonth === '' ? "error" : ""}
                            />
                        </div>
                    </div>
                    <div className="form-group col-sm-3">
                        <div>
                            <label htmlFor="CardExpYear"
                                className={this.state.touched.cardExpYear && this.state.cardInEdit.CardExpYear === '' ? "error" : ""}
                            >Exp Year:</label>
                        </div>
                        <div>
                            <Input
                                type="text"
                                name="CardExpYear"
                                id="CardExpYear"
                                placeholder="YY"
                                pattern="[0123456789][0123456789]"
                                value={this.state.cardInEdit.CardExpYear ?? ""}
                                onChange={this.handleExpYearChange}
                                onBlur={this.handleBlur('cardExpYear')}
                                className={this.state.touched.cardExpYear && this.state.cardInEdit.CardExpYear === '' ? "error" : ""}
                            />
                        </div>
                    </div>
                    <div className="form-group col-sm-3">
                        <div>
                            <label htmlFor="CardCVC"
                                className={this.state.touched.cardCVC && this.state.cardInEdit.CardCVC === '' ? "error" : ""}
                            >CVC Code:</label>
                        </div>
                        <div>
                            <Input
                                type="text"
                                name="CardCVC"
                                id="CardCVC"
                                pattern="[0-9]{3,4}"
                                value={this.state.cardInEdit.CardCVC ?? ""}
                                onChange={this.handleCVCChange}
                                onBlur={this.handleBlur('cardCVC')}
                                className={this.state.touched.cardCVC && this.state.cardInEdit.CardCVC === '' ? "error" : ""}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CardPayment;
